<template>
  <SectionCard
    id="introduce"
    :class="isPcFlag ? 'product-introduction-pc' : 'product-introduction-h5'"
    :isPcFlag="isPcFlag"
    title="产品介绍"
    bgColor="#F8F9FB"
  >
    <div class="introduction-content">
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="item-left">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
        <div class="vertical-bar"><!-- 竖线 --></div>
        <div class="item-right-img">
          <img class="img" :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.product-introduction-pc {
  .introduction-content {
    .item {
      width: 100%;
      height: 423px;
      background-color: #fff;
      box-shadow: 0px 2px 10px 0px #dee5f4;
      border-radius: 8px;
      margin-bottom: 30px;
      // .basisDisplay(center,center);
      .item-left {
        padding: 142px 109px 142px 64px;
        .title {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        .desc {
          width: 336px;
          margin: 10px 0 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 24px;
        }
        .text {
          .basisDisplay(center,center);
          width: 206px;
          height: 34px;
          background: #e63740;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
      }
      .vertical-bar {
        width: 1px;
        height: 360px;
        border: 1px solid #e8e8e8;
        margin: 31px 0;
      }
      .item-right-img {
        width: 58%;
        height: auto;
        padding: 15px;
        margin: 25px auto;
        .img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .item:nth-child(odd) .item-left {
      float: left;
    }
    .item:nth-child(odd) .vertical-bar {
      float: left;
    }
    .item:nth-child(odd) .item-right-img {
      float: right;
    }
    .item:nth-child(even) .item-left {
      float: right;
    }
    .item:nth-child(even) .vertical-bar {
      float: right;
    }
    .item:nth-child(even) .item-right-img {
      float: left;
    }
  }
}
// h5样式
.product-introduction-h5 {
  .introduction-content {
    .item {
      padding: 0.64rem 0;
      background: #ffffff;
      box-shadow: 0px 0.0533rem 0.16rem 0px #dee5f4;
      .item-left {
        .title {
          margin-left: 0.5333rem;
          font-size: 0.3733rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .desc {
          width: 7.4667rem;
          margin: 0.1867rem 0 0.1867rem 0.5333rem;
          // font-size: 0.3733rem;
          font-size: 0.3733rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 0.64rem;
        }
        .text {
          margin-left: 0.5333rem;
          width: 4.5867rem;
          height: 0.6667rem;
          background: #e63740;
          border-radius: 0.1067rem;
          .basisDisplay(center,center);
          font-size: 0.32rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .item:first-child {
      margin-bottom: 0.3733rem;
    }
  }
}
</style>